import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import img from "../../assets/market-opportunity-analysis.webp";
import marketcrad1 from "../../assets/marketcard1.jpeg";
import marketcrad2 from "../../assets/marketcard2.jpeg";
import marketcrad3 from "../../assets/marketcard3.jpg";
import "./market.css";

const Market = () => {
  const data = [
    {
      title: "Government Digitization Push",
      description:
        "Governments in Africa are embracing digitization to improve public services, requiring reliable and efficient printing solutions.",
      img: marketcrad1,
    },
    {
      title: "Education Sector",
      description:
        "Educational institutions are adopting digital tools, creating a need for managed print services in schools and universities.",
      img: marketcrad2,
    },
    {
      title: "Banking & Private Sector",
      description:
        "Banks and businesses demand secure, cost-effective document handling—our AMC services offer just that.",
      img: marketcrad3,
    },
  ];

  return (
    <div style={{ overflow: "hidden" }}>
      <Container className="py-5">
        <Row className="align-items-center justify-content-center">
          {/* <Col md={4} className="text-center mb-4 mb-md-0">
            <img
              src={img}
              alt="Market Opportunity"
              className="img-fluid border p-2 shadow d-none d-md-block"
              style={{ width: "100%", height: "400px", objectFit: "cover" }}
            />
          </Col> */}

          <Col md={10} data-aos="zoom-in">
            <h2 className="title-font text-center mb-3">
              Market Opportunity In Africa
            </h2>
            <p className="text-muted text-center mb-4">
              With our <strong>AMC services</strong>, we provide tailored
              solutions for seamless printer management, cost-effective support,
              and enhanced productivity across key industries.
            </p>

            <Row>
              {data.map((item, idx) => (
                <Col
                  xs={12}
                  md={4}
                  key={idx}
                  className="mb-4"
                  data-aos="fade-right"
                  data-aos-delay={idx * 100}
                >
                  <Card className="h-100 shadow-sm border-0">
                    <div className="card-img-wrapper">
                      <div className="card-img-overlay"></div>
                      <Card.Img
                        variant="top"
                        src={item.img}
                        alt={item.title}
                        className="card-img-zoom "
                        style={{ height: "200px" }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title className="theme-font-color fw-medium fs-6 text-center">
                        {item.title}
                      </Card.Title>
                      <Card.Text
                        className="text-muted small"
                        style={{ textAlign: "justify" }}
                      >
                        {item.description}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Market;
